export const API_DATE_FORMAT = "YYYY-MM-DD";
export const NO_DATA_MESSAGE = "No data available";
export const NO_FUTURE_DATA_MESSAGE = "No future data available";
